import { Sheet } from '@zoomit/mobile-sheet';
import { Modal } from '@zoomit/primitives';
import type { BaseImageType, TopicInfoType} from '@zoomit/web-kit';
import { isMobile } from '@zoomit/web-kit';

import { ReviewModalBody } from './ReviewModalBody';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  rate?: number;
  image: BaseImageType;
  title: string;
  topicInfo: TopicInfoType;
  minCharacter?: number;
  topicType: 'Product' | 'Store';
};

const ReviewTopicModal = (props: Props) => {
  const { isOpen, image, title, onClose, topicInfo, minCharacter, rate, topicType } = props;

  return (
    <>
      {isMobile && (
        <Sheet isOpen={isOpen} onClose={onClose}>
          <Sheet.Container>
            <Sheet.CloseIndicator />
            <ReviewModalBody
              onClose={onClose}
              image={image}
              title={title}
              topicInfo={topicInfo}
              minCharacter={minCharacter}
              rate={rate}
              topicType={topicType}
            />
          </Sheet.Container>
          <Sheet.Backdrop />
        </Sheet>
      )}
      {isOpen && !isMobile && (
        <Modal size={'sm'} onClose={onClose} isOpen={isOpen} isDismissable>
          <ReviewModalBody
            onClose={onClose}
            image={image}
            title={title}
            topicInfo={topicInfo}
            minCharacter={minCharacter}
            rate={rate}
            topicType={topicType}
          />
        </Modal>
      )}
    </>
  );
};

export default ReviewTopicModal;
